export default __webpack_public_path__ + "static/media/sound_off.7a99945a.svg";